module.exports = __webpack_public_path__ + "static/media/visualTools.53a08380.jpg";